<template>
  <div>
    <card>
      <Button type="primary" size="small" style="margin:5px" @click="addVac">新增</Button>
      <Table :columns="vacTable.columns" :data="vacTable.data"></Table>
    </card>
    <vac-form ref="vacForm" v-on:refresh="getVacList"></vac-form>
  </div>
</template>
<script>
  import vacForm from './vaction_Form'
  export default {
    name: 'vacation_index',
    components:{
      vacForm
    },
    data() {
      return {
        vacTable: {
          columns: [
            {
              title: '教师',
              key: 'teacher',
              align: 'center'
            },
            {
              title: '休息日',
              key: 'weekday1',
              align: 'center',
              // render:(h,params) => {
              //   let self = this;
              //   let opArray = [];
              //   let flag = '全天';
              //   let color = 'success';
              //
              //   // opArray.push(h,('Tag', {
              //   //   props: {
              //   //     color: color
              //   //   }
              //   // }, flag));
              //   opArray.push(h,'div',flag);
              //   return h('div', opArray);
              // }
            },
            {
              title: '休息时段',
              key: 'workflag1',
              align: 'center',
              // render: (h, params) => {
              //   let self = this;
              //   let opArray = new Array();
              //   let flag = '全天'
              //   switch (params.row.workflag) {
              //     case 1:
              //       flag = '全天';
              //       break;
              //     case 2:
              //       flag = '早上';
              //       break;
              //     case 3:
              //       flag = '下午';
              //       break;
              //     case 4:
              //       flag = '晚上';
              //       break;
              //     default:
              //       flag = '无'
              //       break;
              //   }
              //   opArray.push(h, ('Tag',
              //     {
              //       props:
              //         {color: 'primary'}
              //     }, flag));
              //   // opArray.push(h,'div',flag)
              //   return h('div', opArray);
              // }
            },
            {
              title: '操作',
              align: 'center',
              render: (h, params) => {
                let self = this;
                let opArray = [];
                opArray.push(h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$refs.vacForm.vacForm.id=params.row.id
                      this.$refs.vacForm.getTeacherList()
                      this.$refs.vacForm.vacForm.teacher_id=(Number)(params.row.teacher_id)
                      this.$refs.vacForm.vacForm.weekday=(Number)(params.row.weekday)
                      this.$refs.vacForm.vacForm.workflag=(Number)(params.row.workflag)
                      this.$refs.vacForm.showModal=true
                    }
                  }
                }, '修改'));
                opArray.push(h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '确认删除?',
                        content: '确认删除该数据,删除老师休假时段将影响到已排课程?',
                        onOk() {
                          this.$api.setting.delVac({id:params.row.id,teacher_id:params.row.teacher_id}).then(res=>{
                            if(res.state=="ok"){
                              this.$Message.success("删除成功，请前往修改排课课程")
                              self.getVacList()
                            }else{
                              this.$Message.error("删除失败")
                            }
                          })
                        },
                        onClose() {

                        }
                      })


                    }
                  }
                }, '删除'));
                return h('div', opArray);
              }
            }

          ],
          data: []
        }
      }
    },
    mounted() {
      this.getVacList()
    },
    methods: {
      getVacList() {
        this.vacTable.data = []
        this.$api.setting.getVacList().then(res => {
          if (res.state == "ok") {
            for(var i=0;i<res.vacList.length;i++ ){
              switch ((Number)(res.vacList[i].weekday)) {
                case 1:
                  res.vacList[i]["weekday1"] = '星期一'
                  break;
                case 2:
                  res.vacList[i]["weekday1"] = '星期二'
                  break;
                case 3 :
                  res.vacList[i]["weekday1"]= '星期三'
                  break;
                case 4:
                   res.vacList[i]["weekday1"] = '星期四'
                  break;
                case 5 :
                  res.vacList[i]["weekday1"] = '星期五'
                  break;
                case 6:
                  res.vacList[i]["weekday1"]= '星期六'
                  break;
                case 7:
                  res.vacList[i]["weekday1"] = '星期日'
                  break;
                default:
                  break;
              }
              switch (res.vacList[i].workflag) {
                case 1:
                  res.vacList[i]["workflag1"] = '全天';
                  break;
                case 2:
                  res.vacList[i]["workflag1"] = '早上';
                  break;
                case 3:
                  res.vacList[i]["workflag1"] = '下午';
                  break;
                case 4:
                  res.vacList[i]["workflag1"] = '晚上';
                  break;
                default:break;
              }
            }
            this.vacTable.data = res.vacList;
          } else {
            this.$Message.error(res.mag)
          }
        })
      },
      addVac(){
        this.$refs.vacForm.vacForm.id=''
        this.$refs.vacForm.getTeacherList()
        this.$refs.vacForm.showModal=true
      }
    }
  }
</script>
